<!-- <h4 class="title">Related Account</h4> -->


<div class="doc-table">
    <div class="card-box">
        <h4 class="title">Customer Available Accounts</h4>
         <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="true" [rows]="5"
        [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [globalFilterFields]="['type']">

        <ng-template pTemplate="header">
            <tr class="thhead">
                <th>
                    Loan / C C no.
                </th>
                <th>
                    Customer ID
                </th>
                <th>
                    Customer Name
                </th>

                <th>
                  Customer Profile
              </th>
              <th>
               A / c Block Code Status
            </th>
            <th>
             Agreement ID
          </th>

          <th>
            Collector
         </th>
         <th>
         Product Name
       </th>
       <th>
      cycle
     </th>
     <th>
      DPD
   </th>
   <th>
   Minimum due / Installments
 </th>
 <th>
  Overdue
</th>
<th>
  Outstanding Amount
</th>
<th>
 Delinquency String
</th>
                <!-- <th>
                    Year of completion
                </th>
                <th>Experience </th>
                <th>Specialization </th>
                <th>Pets handled</th>
                <th>Clinic address</th>
                <th>Certificate</th>
                <th>Govt ID proof </th>
                <th>Photo ID proof</th>
                <th>Created by</th>
                <th>Modified by</th>
                <th>Created at</th>
                <th>Modified at</th> -->
                <th style="width: 110px;text-align:center">
                    Action
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item let-i="rowIndex">
            <tr class="tdrow">
                <td>001254785885</td>
                <td>Record not yet called</td>
                <td>Active</td>
                <td>Emirates Islamic Bank Cards</td>
                <td>Loans</td>
                <td>Champion</td>
                <td>Champion</td>
                <td>Champion</td>
                <td>Champion</td>
                <td>Champion</td>
                <td>Champion</td>
                <td>Champion</td>
                <td>Champion</td>
                <td>Champion</td>
                <!-- <td>Lorem ipsum.</td>
                <td>Lorem ipsum.</td>
                <td>Lorem ipsum.</td>
                <td>Lorem ipsum.</td>
                <td>Lorem ipsum.</td>

                <td>Lorem ipsum.</td> -->
                <!-- <td class="act"><i class="fa fa-file-text" style="background-color: #fff;color: #fd2c3a;"
                        aria-hidden="true"></i></td>
                <td class="act"><i class="fa fa-file-text" style="background-color: #fff;color: #fd2c3a;"
                        aria-hidden="true"></i></td>
                <td class="act"><i class="fa fa-file-text" style="background-color: #fff;color: #fd2c3a;"
                        aria-hidden="true"></i></td> -->
                <!-- <td>7373387504</td> -->
                <!-- <td>
                    User
                </td>
                <td>
                    Admin
                </td>
                <td>
                    16-09-2020
                </td>
                <td>
                    17-09-2020
                </td> -->
                <td class="act">
                    <i style="color: #2196f3;" class="fa fa-pencil-square-o" aria-hidden="true" pTooltip="Edit"></i>
                    <i style="color: #fd2c3a;" class="fa fa-trash" aria-hidden="true" pTooltip="Delete"></i>
                    <!-- <i style="color: #4CAF50;" class="fa fa-info-circle" aria-hidden="true" pTooltip="View"></i> -->
                </td>
            </tr>
        </ng-template>
     </p-table>  </div>

</div>

